var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2859 2.57129H18.8573C19.3119 2.57129 19.748 2.7519 20.0695 3.07339C20.391 3.39488 20.5716 3.83092 20.5716 4.28557V21.4284C20.5716 21.8831 20.391 22.3191 20.0695 22.6406C19.748 22.9621 19.3119 23.1427 18.8573 23.1427H5.143C4.68834 23.1427 4.2523 22.9621 3.93081 22.6406C3.60932 22.3191 3.42871 21.8831 3.42871 21.4284V4.28557C3.42871 3.83092 3.60932 3.39488 3.93081 3.07339C4.2523 2.7519 4.68834 2.57129 5.143 2.57129H7.71442",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.572 0.857422H9.42913C8.48236 0.857422 7.71484 1.62493 7.71484 2.57171V3.42885C7.71484 4.37562 8.48236 5.14314 9.42913 5.14314H14.572C15.5188 5.14314 16.2863 4.37562 16.2863 3.42885V2.57171C16.2863 1.62493 15.5188 0.857422 14.572 0.857422Z",
    stroke: "white",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.af896990024ebb5636e0d27856a99db6.svg";
export { ForwardRef as ReactComponent };